import { render, staticRenderFns } from "./KifForm.vue?vue&type=template&id=717eaf9c&"
import script from "./KifForm.vue?vue&type=script&lang=js&"
export * from "./KifForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports